module.exports = __webpack_public_path__ + "img/sda-logo.f9cd8c8d.svg";